import {
  Icon,
  LinearProgress,
  List,
  ListItem,
  ListItemText,
  Popover,
  Table,
  TableBody,
  TableCell,
  TablePagination,
  TableRow,
  Typography,
  IconButton
} from "@material-ui/core";
import EnhancedTableHead from "components/EnhancedTableHead/EnhancedTableHead.jsx";
import Snackbar from "components/Snackbar/Snackbar.jsx";
import { GetUserId, GetUserToken, Logout } from "helpers/UserHelper";
import { SearchDataSet } from "helpers/Search";
import React, { Component } from "react";
import { Query, compose, graphql } from "react-apollo";
import { Redirect } from "react-router";
import BaseTablePageContent from "./components/BaseTablePageContent.jsx";

//Q&Ms
import { BrokerAssistants } from "queries/Assistant_Assignment/BrokerAssistants";
import {
  AA_AcceptRequest,
  AA_DeclineRequest,
  AA_SendRequest
} from "queries/Assistant_Assignment/Mutations";

const columnData = [
  {
    id: "edit",
    numeric: false,
    disablePadding: true,
    label: "",
    noSort: true,
    width: "30px"
  },
  {
    id: "ab_Id",
    numeric: false,
    disablePadding: true,
    label: "Status",
    noSort: true
  },
  { id: "su_name", numeric: false, disablePadding: true, label: "Name" },
  { id: "su_email", numeric: false, disablePadding: true, label: "Email" }
];

class AssistantAssignment extends Component {
  state = {
    page: 0,
    rowsPerPage: 10,
    order: "desc",
    orderBy: "Name",
    searchTerm: "",
    loadingSearch: false,
    data: [],
    searchData: [],
    openMenus: [],
    anchorTop: 0,
    anchorLeft: 0,
    popoverOpen: false,
    br: false,
    snackBarColor: "",
    snackBarText: "",
    statuses: [0, 1, 2, 3]
  };

  handleSearch = event => {
    this.setState({ searchTerm: event.target.value });

    let values = event.target.value.split(" ");
    var brokers = this.state.data;
    var inc = ["su_name", "su_surname", "su_email"];

    var filteredData = SearchDataSet(brokers, values, inc);
    this.setState({ searchData: filteredData });
  };

  handleChangePage = (event, page) => {
    this.setState({ page });
  };

  handleChangeRowsPerPage = event => {
    this.setState({ rowsPerPage: event.target.value });
  };

  handleRequestSort = (event, property) => {
    const orderBy = property;
    let order = "desc";

    if (this.state.orderBy === property && this.state.order === "desc") {
      order = "asc";
    }

    this.setState({ order, orderBy });
  };

  getSorting(order, orderBy) {
    return order === "desc"
      ? (a, b) => (b[orderBy] < a[orderBy] ? -1 : 1)
      : (a, b) => (a[orderBy] < b[orderBy] ? -1 : 1);
  }

  handleClaim = b => {};

  handleRemove = () => {};

  handleClick = (event, id) => {
    this.setState({ anchorTop: event.clientY, anchorLeft: event.clientX });

    var openMenus = this.state.openMenus.slice();
    openMenus.filter(x => x.id === id)[0].open = true;
    this.setState({ openMenus: openMenus, popoverOpen: true });
  };

  handleClose = id => {
    var openMenus = this.state.openMenus.slice();
    openMenus.filter(x => x.id === id)[0].open = false;
    this.setState({ openMenus: openMenus, popoverOpen: false });
  };

  showNotification = place => {
    if (!this.state[place]) {
      var x = [];
      x[place] = true;
      this.setState(x);
      setTimeout(
        function() {
          x[place] = false;
          this.setState(x);
        }.bind(this),
        3000
      );
    }
  };

  toggleFilterItem = (refetch, item) => {
    if (item !== "all") {
      let statuses = [...this.state.statuses];
      if (statuses.includes(item)) {
        statuses = statuses.filter(s => s !== item);
      } else {
        statuses.push(item);
      }

      this.setState({ statuses: statuses });
      refetch();
    }
  };

  acceptRequest = (refetch, assistantId) => {
    const input = {
      assistantId: assistantId,
      brokerId: GetUserId(),
      token: GetUserToken()
    };

    this.props
      .AA_AcceptRequest({
        variables: {
          input
        }
      })
      .then(resp => {
        refetch();
        this.showNotification("br");
        this.setState({
          snackBarColor: "success",
          snackBarText: "Request Accepted"
        });
      })
      .catch(error => {
        console.log("err", error);
      });
  };

  declineRequest = (refetch, assistantId, messageText) => {
    const input = {
      assistantId: assistantId,
      brokerId: GetUserId(),
      token: GetUserToken()
    };

    this.props
      .AA_DeclineRequest({
        variables: {
          input
        }
      })
      .then(resp => {
        refetch();
        this.showNotification("br");
        this.setState({
          snackBarColor: "danger",
          snackBarText: messageText
        });
      })
      .catch(error => {
        console.log("err", error);
      });
  };

  sendRequest = (refetch, assistantId) => {
    const input = {
      assistantId: assistantId,
      brokerId: GetUserId(),
      token: GetUserToken()
    };

    this.props
      .AA_SendRequest({
        variables: {
          input
        }
      })
      .then(resp => {
        refetch();
        this.showNotification("br");
        this.setState({
          snackBarColor: "success",
          snackBarText: "Request Sent"
        });
      })
      .catch(error => {
        console.log("err", error);
      });
  };

  render() {
    return (
      <Query
        query={BrokerAssistants}
        variables={{
          userId: GetUserId(),
          token: GetUserToken(),
          statuses: this.state.statuses
        }}
        fetchPolicy="network-only"
      >
        {({ loading, error, data, refetch }) => {
          if (loading)
            return (
              <React.Fragment>
                <BaseTablePageContent
                  handleSearch={this.handleSearch}
                  title="Assistant Assignment"
                  toggleFilterItem={item =>
                    this.toggleFilterItem(refetch, item)
                  }
                  filters={this.state.statuses}
                >
                  <LinearProgress />
                </BaseTablePageContent>
              </React.Fragment>
            );

          if (
            error &&
            error.message &&
            error.message === "GraphQL error: invalid token"
          ) {
            Logout();
            return <Redirect to="/app/portal/login" />;
          }

          if (this.state.data.length !== data.BrokerAssistants.length) {
            this.setState({ data: data.BrokerAssistants });
          }

          let qData = [];
          if (
            this.state.searchData.length > 0 &&
            this.state.searchTerm !== ""
          ) {
            qData = this.state.searchData.slice();
            qData.sort(this.getSorting(this.state.order, this.state.orderBy));
          } else {
            qData = data.BrokerAssistants.slice();
            qData.sort(this.getSorting(this.state.order, this.state.orderBy));
          }

          if (qData && this.state.openMenus.length !== qData.length) {
            let openMenus = [];

            qData.map(b => {
              openMenus.push({
                open: false,
                id: b.su_ID
              });

              return b;
            });

            this.setState({ openMenus: openMenus });
          }

          return (
            <BaseTablePageContent
              handleSearch={this.handleSearch}
              title="Assistant Assignment"
              toggleFilterItem={item => this.toggleFilterItem(refetch, item)}
              filters={this.state.statuses}
            >
              <Table>
                <EnhancedTableHead
                  order={this.state.order}
                  orderBy={this.state.orderBy}
                  onRequestSort={this.handleRequestSort}
                  rowCount={
                    this.state.searchData.length < 1 &&
                    this.state.searchTerm !== ""
                      ? this.state.searchData.length
                      : qData.length
                  }
                  columnData={columnData}
                />
                <TableBody>
                  {this.state.searchData.length < 1 &&
                  this.state.searchTerm !== "" ? (
                    <TableRow>
                      <TableCell>
                        <h3>No results found</h3>
                      </TableCell>
                    </TableRow>
                  ) : (
                    qData
                      .slice(
                        this.state.page * this.state.rowsPerPage,
                        this.state.page * this.state.rowsPerPage +
                          this.state.rowsPerPage
                      )
                      .map(assistant => {
                        console.log("assistant", assistant);
                        return (
                          <TableRow
                            className="sqDataTable"
                            key={assistant.su_ID}
                            onClick={e =>
                              this.state.popoverOpen === false
                                ? this.handleClick(e, assistant.su_ID)
                                : null
                            }
                          >
                            <TableCell
                              style={{
                                padding: "0px",
                                borderRight: "1px solid #e0e0e0",
                                backgroundColor: "white"
                              }}
                            >
                              <IconButton
                                onClick={e =>
                                  this.state.popoverOpen === false
                                    ? this.handleClick(e, assistant.su_ID)
                                    : null
                                }
                              >
                                <Icon>more_vert</Icon>
                              </IconButton>
                            </TableCell>
                            <TableCell
                              style={{
                                borderTop: "1px solid rgba(224, 224, 224, 1)",
                                width: "160px",
                                paddingRight: "0px"
                              }}
                            >
                              <div style={{ display: "flex" }}>
                                {assistant.ab_Id ? (
                                  assistant.status === 2 ? (
                                    <React.Fragment>
                                      <Icon
                                        style={{
                                          marginRight: "10px",
                                          color: "#00ce00"
                                        }}
                                      >
                                        done_all
                                      </Icon>
                                      <Typography
                                        variant="caption"
                                        style={{
                                          wordWrap: "break-word",
                                          position: "relative",
                                          top: "3px"
                                        }}
                                      >
                                        Assigned
                                      </Typography>
                                    </React.Fragment>
                                  ) : assistant.status === 1 ? (
                                    <React.Fragment>
                                      <Icon
                                        style={{
                                          marginRight: "10px",
                                          color: "#ffae57"
                                        }}
                                      >
                                        priority_high
                                      </Icon>
                                      <Typography
                                        variant="caption"
                                        style={{
                                          wordWrap: "break-word",
                                          position: "relative",
                                          top: "3px"
                                        }}
                                      >
                                        Request Sent
                                      </Typography>
                                    </React.Fragment>
                                  ) : assistant.status === 0 ? (
                                    <React.Fragment>
                                      <Icon
                                        style={{
                                          marginRight: "10px",
                                          color: "#ffae57"
                                        }}
                                      >
                                        priority_high
                                      </Icon>
                                      <Typography
                                        variant="caption"
                                        style={{
                                          wordWrap: "break-word",
                                          position: "relative",
                                          top: "3px"
                                        }}
                                      >
                                        Request Recieved
                                      </Typography>
                                    </React.Fragment>
                                  ) : null
                                ) : (
                                  <React.Fragment>
                                    <Icon
                                      style={{
                                        marginRight: "10px",
                                        color: "#84848494"
                                      }}
                                    >
                                      help_outline
                                    </Icon>
                                    <Typography
                                      variant="caption"
                                      style={{
                                        wordWrap: "break-word",
                                        position: "relative",
                                        top: "3px"
                                      }}
                                    >
                                      Unassigned
                                    </Typography>
                                  </React.Fragment>
                                )}
                              </div>
                            </TableCell>
                            <TableCell>
                              {assistant.su_name} {assistant.su_surname}
                            </TableCell>
                            <TableCell>{assistant.su_email}</TableCell>
                            <Popover
                              open={
                                this.state.openMenus.length > 0 &&
                                this.state.openMenus.filter(
                                  m => m.id === assistant.su_ID
                                ).length > 0
                                  ? this.state.openMenus.filter(
                                      m => m.id === assistant.su_ID
                                    )[0].open
                                  : false
                              }
                              anchorReference="anchorPosition"
                              anchorPosition={{
                                left: this.state.anchorLeft,
                                top: this.state.anchorTop
                              }}
                              onClose={() => this.handleClose(assistant.su_ID)}
                            >
                              <List component="nav">
                                {!assistant.ab_Id ? (
                                  <ListItem
                                    button
                                    onClick={() => {
                                      this.handleClose(assistant.su_ID);
                                      this.sendRequest(
                                        refetch,
                                        assistant.su_ID
                                      );
                                    }}
                                  >
                                    <ListItemText primary="Request Assignment" />
                                  </ListItem>
                                ) : assistant.status === 1 ? (
                                  <ListItem
                                    button
                                    onClick={() => {
                                      this.handleClose(assistant.su_ID);
                                      this.declineRequest(
                                        refetch,
                                        assistant.su_ID,
                                        "Request Canceled"
                                      );
                                    }}
                                  >
                                    <ListItemText primary="Cancel Request" />
                                  </ListItem>
                                ) : assistant.status === 0 ? (
                                  <React.Fragment>
                                    <ListItem
                                      button
                                      onClick={() => {
                                        this.handleClose(assistant.su_ID);
                                        this.acceptRequest(
                                          refetch,
                                          assistant.su_ID
                                        );
                                      }}
                                    >
                                      <ListItemText primary="Accept Request" />
                                    </ListItem>
                                    <ListItem
                                      button
                                      onClick={() => {
                                        this.handleClose(assistant.su_ID);
                                        this.declineRequest(
                                          refetch,
                                          assistant.su_ID,
                                          "Request Declined"
                                        );
                                      }}
                                    >
                                      <ListItemText primary="Decline Request" />
                                    </ListItem>
                                  </React.Fragment>
                                ) : assistant.status === 2 ? (
                                  <ListItem
                                    button
                                    onClick={() => {
                                      this.handleClose(assistant.su_ID);
                                      this.declineRequest(
                                        refetch,
                                        assistant.su_ID,
                                        "Assistant Unassigned"
                                      );
                                    }}
                                  >
                                    <ListItemText primary="Unassign" />
                                  </ListItem>
                                ) : null}
                              </List>
                            </Popover>
                          </TableRow>
                        );
                      })
                  )}
                  <TableRow>
                    <TablePagination
                      count={
                        this.state.searchData.length < 1 &&
                        this.state.searchTerm !== ""
                          ? this.state.searchData.length
                          : qData.length
                      }
                      rowsPerPage={this.state.rowsPerPage}
                      page={this.state.page}
                      backIconButtonProps={{
                        "aria-label": "Previous Page"
                      }}
                      nextIconButtonProps={{
                        "aria-label": "Next Page"
                      }}
                      onChangePage={this.handleChangePage}
                      onChangeRowsPerPage={this.handleChangeRowsPerPage}
                    />
                  </TableRow>
                </TableBody>
              </Table>
              <Snackbar
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "right"
                }}
                place="br"
                color={this.state.snackBarColor}
                message={this.state.snackBarText}
                open={this.state.br}
                closeNotification={() => this.setState({ br: false })}
                close
              />
            </BaseTablePageContent>
          );
        }}
      </Query>
    );
  }
}

AssistantAssignment = compose(
  graphql(AA_AcceptRequest, { name: "AA_AcceptRequest" }),
  graphql(AA_DeclineRequest, { name: "AA_DeclineRequest" }),
  graphql(AA_SendRequest, { name: "AA_SendRequest" })
)(AssistantAssignment);

export default AssistantAssignment;



// WEBPACK FOOTER //
// ./src/views/Brokers/AssistantAssignment.jsx